import orderBy from 'lodash/orderBy'

import { TransformContext, StoryblokStory } from '~/lib/storyblok'
import { Location } from './types'
import { relations } from '~/storyblok/relations'
import { transformLocation } from './transformLocation'

export async function fetchLocations(context: TransformContext): Promise<Location[]> {
  const stories = await context.client.getAll('cdn/stories', {
    // TODO: correctly load 'draft' or 'published'.
    version: context.preview || process.env.STORYBLOK_FORCE_DRAFT ? 'draft' : 'published',
    resolve_relations: relations?.join(',') || '',
    resolve_links: 'url',
    starts_with: 'restaurants-geschaefte/',
    is_startpage: false,
  })

  const locations: Location[] = await Promise.all(
    stories.map(async (story: StoryblokStory): Promise<Location> => {
      return await transformLocation(story, context)
    }),
  )

  const sortedLocations = orderBy(locations, [(location: Location) => location.name.toLowerCase()], ['asc'])

  return sortedLocations
}
